<template>
    <div class="expandable_section" :class="{ collapsed: !isExpanded }">
        <div class="section_header" @click="toggleExpanded">
            <span class="section_icon">{{ icon }}</span>
            <h3 class="section_title">{{ title }}</h3>
            <div class="header_actions">
                <button
                    v-if="refreshable"
                    class="refresh_button"
                    @click.stop="$emit('refresh')"
                    :disabled="isLoading"
                    :class="{ spinning: isLoading }"
                    title="Refresh"
                >
                    🔄
                </button>
                <span class="expand_indicator">
                    {{ isExpanded ? '▼' : '▶' }}
                </span>
            </div>
        </div>
        <div v-show="isExpanded" class="section_content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ExpandableSection',
    props: {
        title: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            default: '📁',
        },
        defaultExpanded: {
            type: Boolean,
            default: false,
        },
        refreshable: {
            type: Boolean,
            default: false,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['refresh'],
    data() {
        return {
            isExpanded: this.defaultExpanded,
        };
    },
    methods: {
        toggleExpanded() {
            this.isExpanded = !this.isExpanded;
        },
    },
};
</script>

<style scoped>
.expandable_section {
    border: 1px solid var(--border-color, #e5e7eb);
    border-radius: 8px;
    margin: 10px 0;
    overflow: hidden;
    background: var(--main-color);
}

.section_header {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    background: var(--background-secondary, #f9fafb);
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s ease;
}

.section_header:hover {
    background: var(--background-hover, #f3f4f6);
}

.section_icon {
    font-size: 18px;
    margin-right: 10px;
}

.section_title {
    flex: 1;
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: var(--text-color, #111827);
}

.header_actions {
    display: flex;
    align-items: center;
    gap: 10px;
}

.refresh_button {
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 16px;
    padding: 4px 8px;
    border-radius: 4px;
    transition: background-color 0.2s ease;
}

.refresh_button:hover {
    background: rgba(0, 0, 0, 0.1);
}

.refresh_button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.refresh_button.spinning {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.expand_indicator {
    font-size: 12px;
    color: var(--text-color-secondary, #6b7280);
    transition: transform 0.2s ease;
}

.section_content {
    padding: 16px;
    border-top: 1px solid var(--border-color, #e5e7eb);
    background: var(--main-color);
    color: var(--background-text, #ffffff);
}

/* Collapsed state styling */
.expandable_section.collapsed .section_header {
    border-bottom: none;
}
</style>
